import React, {Component} from 'react';
import '../../Compact.css';

let _this;

class VoiceTranslatorCompact extends Component {

    constructor(props, context) {
        super(props);
        _this = this;
    }

    render() {
        return <div className="product-card">
            <div className="product-card-content">
                <div className="product-info">
                    <div>
                        <img style={{borderRadius: '10%', margin: '0 16px 0 16px'}} className="roundrect"
                             src="/voicebridge192.png" align="left"
                             alt="app icon"
                             width="128px"/>
                        <div>
                            <h2>Speech Translator: Be Heard</h2>
                            <h3>Speak anywhere in the world and understand anyone, no matter what language they
                                speak.</h3>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <div style={{margin: '0 24px 0 24px'}}>
                        <h4>WORKS ON IPHONE AND ANDROID</h4>
                    </div>
                    <div className="divider"></div>
                    <div className="product-links" style={{margin: '16px 0 0 16px'}}>
                        <a href="https://apps.apple.com/us/app/speech-translator-be-heard/id6479205508"
                           target="_blank"
                           rel="noopener">
                            <img src="/app_store.png" alt="itunes" height="36" hspace="5" vspace="5"/>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.answersolutions.talkwise.voicebridge"
                           target="_blank"
                           rel="noopener">
                            <img src="/google_play.svg" alt="google play" height="36" hspace="5" vspace="5"/>
                        </a>
                    </div>
                    <div className="divider"></div>
                    <div className="product-footer">
                        <a href="https://wisetalkapp.com"></a>
                        <a href="#voice-translator-product"
                           role="button"
                           className="learn-more-button"
                           onClick={() => _this.props.navigate('VoiceTranslatorProduct')}
                        >Learn More →</a>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default VoiceTranslatorCompact;